import { create } from 'zustand'
import { PAGE_STATE } from '../helpers'

let errorTimer, messageTimer, progressTimer
const useStore = create((set, get) => ({
  applicationName: undefined,
  disabled: false,
  error: '',
  imgSrcLogin: undefined,
  imgAltLogin: '',
  imgSrcLogo: undefined,
  imgAltLogo: '',
  message: '',
  pageState: PAGE_STATE.DEFAULT,
  progress: -1,

  actions: {
    setApplicationName: (applicationName) => set(() => ({ applicationName })),
    setDisabled: (disabled) => set(() => ({ disabled })),
    setError: (error) => {
      clearTimeout(errorTimer)
      set(() => ({ error }))
      errorTimer = setTimeout(() => {
        set(() => ({ error: '' }))
      }, 30000)
    },
    setImgSrcLogin: (imgSrcLogin) => set(() => ({ imgSrcLogin })),
    setImgAltLogin: (imgAltLogin) => set(() => ({ imgAltLogin })),
    setImgSrcLogo: (imgSrcLogo) => set(() => ({ imgSrcLogo })),
    setImgAltLogo: (imgAltLogo) => set(() => ({ imgAltLogo })),
    setMessage: (message) => {
      clearTimeout(messageTimer)
      set(() => ({ message }))
      messageTimer = setTimeout(() => {
        set(() => ({ message: '' }))
      }, 30000)
    },
    setPageState: (pageState) => set(() => ({ pageState })),
    progressStart: () => get().actions.setProgress(20),
    progressEnd: () => {
      const currentProgress = get().progress
      if (currentProgress > -1 && currentProgress < 100) {
        get().actions.setProgress(100)
      }
    },
    setProgress: (progress) => {
      clearTimeout(progressTimer)
      set(() => ({ progress }))
      if (progress >= 100) {
        progressTimer = setTimeout(() => {
          set(() => ({ progress: -1 }))
        }, 400)
      }
    }
  }
}))

const initialStoreState = useStore.getState()
export const initializeStoreTestState = () =>
  useStore.setState(initialStoreState, true)
export const getStoreTestState = useStore.getState

export const useApplicationName = () =>
  useStore((state) => state.applicationName)
export const useDisabled = () => useStore((state) => state.disabled)
export const useError = () => useStore((state) => state.error)
export const useImgSrcLogin = () => useStore((state) => state.imgSrcLogin)
export const useImgAltLogin = () => useStore((state) => state.imgAltLogin)
export const useImgSrcLogo = () => useStore((state) => state.imgSrcLogo)
export const useImgAltLogo = () => useStore((state) => state.imgAltLogo)
export const useMessage = () => useStore((state) => state.message)
export const usePageState = () => useStore((state) => state.pageState)
export const useProgress = () => useStore((state) => state.progress)

export const useActions = () => useStore((state) => state.actions)
